import moment from "moment";
import {Shift} from "@/model/api/Shift";

export interface BrokersMessage {
  subject: string;
  text: string;
}

// Testo standard del messaggio di reclutamento verso i brokers di una WRS.
// Il placeholder {trucks_required} viene sostituito per-broker dal backend.
export function buildBrokersMessage(shift: Shift, enableWeatherConditions: boolean): BrokersMessage {
  const weather = (enableWeatherConditions === true) ? "\nWeather: " + shift.weather_condition : "";
  let subject: string;
  let text = `${moment(shift.start_datetime).format('MM/DD/YYYY hh:mma')}
Job site: ${shift.job_site || '-'}
Load site: ${shift.zone_load?.name}
Dump site: ${shift.zone_dump?.name}
Contract: ${shift.contract?.name}${weather}`;

  if (shift.trucks_required_indipendent) {
    subject = 'THIS IS A FIRST COME, FIRST SERVED SHIFT!';
    text = `The request is for ${shift.trucks_required} amount of trucks for the job:

${text}
Start Date: ${moment(shift.start_datetime).format('YYYY-MM-DD hh:mm A')}`;
  } else {
    subject = `Trucks required ${moment(shift.start_datetime).format('MM/DD/YYYY hh:mma')}`;
    text += `
Driver required: {trucks_required}
The positions must be allocated in the portal or accepted in the app within 1 HOUR or it will be offered to another broker`;
  }

  return { subject, text };
}
